import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA,  NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
// Importing components.............
import { AppComponent } from './app.component';
import { LoginComponent } from './modules/login/components/login/login.component';
import { NotFoundComponent } from './modules/not-found/not-found.component';
// import { SelectDbComponent } from './select-db/select-db.component';
import { AuthServiceService } from './core/services/AuthService.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthguardGuard } from './core/guards/authguard.guard';
import { TokenExpireInterceptor } from './core/TokenExpireInterceptor.interceptor';
import { NgxPaginationModule } from 'ngx-pagination';
// import { NgxInactivity } from 'ngx-inactivity';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RegistationServiceService } from './modules/HospitalPanel/components/ha-register/reg-services/registation-service.service';
import { HaRegisterComponent } from './modules/HospitalPanel/components/ha-register/ha-register/ha-register.component';
import { WebUserService } from './core/services/WebUser.service';
import { ForgotPasswordComponent } from './modules/login/components/forgot-password/forgot-password.component';
import { ForgotPasswordService } from './modules/login/services/ForgotPassword.service';
import { ForgotChangePasswordComponent } from './modules/login/components/forgot-change-password/forgot-change-password.component';
import { ConfirmpasswordDirective } from './modules/SuperAdmin/directives/confirmPassword.directive';
import { PaRegistrationComponent } from './modules/PatientPanel/components/Pa-register/pa-registration/pa-registration.component';
import { PaRegistrationService } from './modules/PatientPanel/components/Pa-register/PaRegistration.service';
import { InvoiceDetailsComponent } from './modules/invoice-details/invoice-details.component';
import { PaypalManagementComponent } from './modules/Paypal/components/paypal-management/paypal-management.component';
import { PaypalManagementProductComponent } from './modules/Paypal/components/paypal-management-product/paypal-management-product.component';
import { PaypalManagementCustomerInfoComponent } from './modules/Paypal/components/paypal-management-customer-info/paypal-management-customer-info.component';
import { PaypalManagementService } from './modules/Paypal/services/PaypalManagement.service';
import { HaConfirmPasswordGlobalDirective } from './modules/HospitalPanel/directives/HaConfirmPasswordGlobal.directive';
import { PaypalPaymentViaLinkComponent } from './modules/Paypal/components/paypal-payment-via-link/paypal-payment-via-link.component';
import { IpsPaymentViaLinkServiceService } from './core/services/IpsPaymentViaLink.service';
import { ForgotUsernameComponent } from './modules/login/components/forgot-username/forgot-username.component';
import { RegisterConfirmPasswordDirective } from './modules/login/directives/RegisterConfirmPassword.directive';
import {  QRCodeModule } from 'ng-qrcode';
import { appRoutingModule } from './app-routing.module';
import { SaPaypalServiceService } from './modules/SuperAdmin/services/SaPaypalService.service';
import { SurveyViaLinkComponent } from './modules/survey-via-link/survey-via-link.component';
import { SurveyViaLinkServiceService } from './core/services/SurveyViaLink.service';
import { AlertMessageComponent } from './modules/alert-message/alert-message.component';


@NgModule({
  declarations: [

    AppComponent,
    LoginComponent,
    NotFoundComponent,
    HaRegisterComponent,
    ForgotPasswordComponent,
    ForgotChangePasswordComponent,
    ConfirmpasswordDirective,
    PaRegistrationComponent,
    InvoiceDetailsComponent,
    PaypalManagementComponent,
    PaypalManagementProductComponent,
    PaypalManagementCustomerInfoComponent,
    HaConfirmPasswordGlobalDirective,
    PaypalPaymentViaLinkComponent,
    ForgotUsernameComponent,
    RegisterConfirmPasswordDirective,
    SurveyViaLinkComponent,
    AlertMessageComponent,

  ],
  imports: [

    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    QRCodeModule,
    appRoutingModule,
    NgxPaginationModule,
    InfiniteScrollModule,
    // NgxInactivity

  ],
  providers: [

    AuthServiceService,
    AuthguardGuard,
    RegistationServiceService,
    WebUserService,
    PaypalManagementService,
    IpsPaymentViaLinkServiceService,
    ForgotPasswordService,
    PaRegistrationService,
    SaPaypalServiceService,
    SurveyViaLinkServiceService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenExpireInterceptor,
      multi: true
    },
    AppComponent


  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
